import type { RoutesData } from '@/router/routerInitPlugin'
import OgImg from '@/assets/og_image.jpeg?url'
// import { gamesUtils } from '@/compositions/gamesUtils'
import { buildLangRoute } from '@/router/langRouteBuilder'
import { routesTranslations } from '@/router/routesTranslations'

export default (): RoutesData[] => {
  return [
    ...buildLangRoute({
      path: `/${routesTranslations['home-page']?.en?.slug}`,
      name: 'home-page',
      component: () => import('@/pages/index/IndexPage.vue'),
      meta: { pageData: { image: OgImg } }
    }),
    ...buildLangRoute({
      path: `/${routesTranslations['game-page']?.en?.slug}`,
      name: 'game-page',
      component: () => import('@/pages/game/GamePage.vue'),
      meta: {
        pageLazyData: (routeParams, routeLocale) => {
          const game = gamesUtils.listById?.[routeParams?.gameID || '']
          return {
            image: game?.gameBanner || OgImg,
            templateVariables: { gameName: game?.name || '' },
            description: routesTranslations?.['game-page']?.[routeLocale]?.descriptionPerGame?.[game?.gameKey || ''] || routesTranslations?.['game-page']?.[routeLocale]?.description || ''
          }
        }
      },
      ssg: Object.entries(gamesUtils.list).map(([, gameData]) => {
        return {
          gameID: gameData.id
        }
      })
    }),
    ...buildLangRoute({
      path: `/${routesTranslations['game-product-page']?.en?.slug}`,
      name: 'game-product-page',
      component: () => import('@/pages/game/OfferPage.vue'),
      meta: {
        pageLazyData: (routeParams, routeLocale) => {
          const game = gamesUtils.listById?.[routeParams?.gameID || '']
          return {
            image: game?.gameBanner || OgImg,
            title: (routesTranslations['game-product-page']?.[routeLocale]?.title || '').replace(' {offerID} ', ' '),
            description: (routesTranslations['game-product-page']?.[routeLocale]?.description || '').split('(')?.[0]?.trim() || '',
            templateVariables: { gameName: game?.name || '' }
          }
        }
      },
      ssg: Object.entries(gamesUtils.list).map(([, gameData]) => {
        return {
          gameID: gameData.id,
          offerID: '000'
        }
      })
    }, { ssgSharedRoute: true }),
    ...buildLangRoute({
      path: `/${routesTranslations['help-page']?.en?.slug}`,
      name: 'help-page',
      component: () => import('@/pages/info/HelpPage.vue'),
      meta: { pageData: { image: OgImg } }
    }),
    ...buildLangRoute({
      path: `/${routesTranslations['about-page']?.en?.slug}`,
      name: 'about-page',
      component: () => import('@/pages/info/AboutPage.vue'),
      meta: { pageData: { image: OgImg } }
    }),
    ...buildLangRoute({
      path: `/${routesTranslations['activate-goat-offer']?.en?.slug}`,
      name: 'activate-goat-offer',
      component: () => import('@/pages/activate/GoatOffer.vue'),
      meta: { pageData: { image: OgImg } }
    }),
    ...(import.meta.env.VITE_PROD !== 'on'
      ? [{
          path: '/admin/add-game',
          name: 'admin-add-game',
          component: () => import('@/pages/admin/AddGamePage.vue'),
          meta: { pageData: { title: 'Admin — Add Game', description: '' } }
        } as RoutesData]
      : [])
  ]
}
